export const SET_COUPON_MODAL_IS_VISIBLE = 'SET_COUPON_MODAL_IS_VISIBLE';
export const COUPON_POST_SUCCESS = 'COUPON_POST_SUCCESS';
export const SET_IS_REQUESTING = 'SET_IS_REQUESTING';

export const ADD_NEW_PROMO_CODE = 'ADD_NEW_PROMO_CODE';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const SET_INVALID_PROMO_CODE = 'SET_INVALID_PROMO_CODE';
export const SET_VALID_PROMO_CODE = 'SET_VALID_PROMO_CODE';